// Mirrors back-end/backend-monolith/src/content/content.constants.ts. Kept in sync
// so the forms enforce the same limits the backend validates.
export const CONTENT_TITLE_MAX_LENGTH = 120;
export const CONTENT_DESCRIPTION_MAX_LENGTH = 300;
export const CONTENT_SUBDOMAIN_MAX_LENGTH = 100;
export const CONTENT_VIDEO_FULL_DESCRIPTION_MAX_LENGTH = 300;
export const CONTENT_POST_BODY_MAX_LENGTH = 300;
export const CONTENT_ARTICLE_SECTION_TEXT_MAX_LENGTH = 2000;
export const CONTENT_ARTICLE_TOTAL_TEXT_MAX_LENGTH = 20000;
export const CONTENT_REMOVAL_REASON_MAX_LENGTH = 500;
export const CONTENT_THUMBNAIL_MIN_WIDTH = 400;
export const CONTENT_THUMBNAIL_MIN_HEIGHT = 400;
